
import Register from '../components/Auth/Register';

// Functional component that renders the Register component
function RegisterPage() {
  return <Register />;
}

export default RegisterPage;
